
// outsource dependencies
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { create } from 'redux-saga-controller';
import { takeEvery, put, call, select } from 'redux-saga/effects';

// local dependencies
import { POSTS, APP_TITLE } from '../../constant';
import { instanceAPI, SweetAlert } from '../../services';

// configure
export const postsListCtrl = create({
  prefix: 'posts-list',
  actions: {
    initialize: 'INITIALIZE',
    deleteItem: 'DELETE_ITEM',
    updateFilter: 'UPDATE_FILTER',
  },
  initial: {
    list: [],
    disabled: false,
    initialized: false,
    errorMessage: null,
    // filter
    page: 0,
    size: 10,
    search: '',
    sortD: false,
    totalPages: 0,
    sortF: 'like',
  },
  subscriber: function * () {
    yield takeEvery(postsListCtrl.action.initialize.TYPE, initializeSaga);
    yield takeEvery(postsListCtrl.action.deleteItem.TYPE, deleteItemSaga);
    yield takeEvery(postsListCtrl.action.updateFilter.TYPE, updateFilterSaga);
  }
});

function * initializeSaga () {
  yield put(postsListCtrl.action.clearCtrl());
  const query = yield call(POSTS.QUERY);
  yield call(updateFilterSaga, { payload: { ...query } });
  yield put(postsListCtrl.action.updateCtrl({ initialized: true }));
}

function * updateFilterSaga ({ payload }) {
  yield put(postsListCtrl.action.updateCtrl({ ...payload, disabled: true }));
  try {
    const { page, search, size, sortF, sortD, } = yield select(postsListCtrl.select);
    // TODO Wait BE implementation
    const { content, totalPages, pageNumber } = yield call(instanceAPI, {
      method: 'POST',
      data: { search },
      url: 'post/feed',
      params: { size, page, sort: [`${sortF},${sortD ? 'DESC' : 'ASC'}`] }
    });
    yield put(postsListCtrl.action.updateCtrl({ list: _.uniqBy(content, 'id'), totalPages, page: pageNumber }));
    const latest = yield select(postsListCtrl.select);
    yield call(POSTS.REPLACE, {}, latest);
  } catch ({ message }) {
    yield put(postsListCtrl.action.updateCtrl({ errorMessage: message }));
  }
  yield put(postsListCtrl.action.updateCtrl({ disabled: false }));
}

function * deleteItemSaga ({ payload }) {
  const id = _.get(payload, 'id');
  const link = _.get(payload, 'link');
  try {
    const confirmation = yield call(SweetAlert.confirm, {
      title: `Are you sure you want to delete post: ${link}?`
    });
    if (!confirmation.value) { return; }
    yield put(postsListCtrl.action.updateCtrl({ disabled: true }));
    // TODO wait BE implementation
    yield call(instanceAPI, { method: 'DELETE', url: '/posts', data: [id] });
    yield call(toastr.success, APP_TITLE, 'Post successfully deleted!');
    yield put(postsListCtrl.action.initialize({}));
  } catch ({ message }) {
    yield call(SweetAlert.error, { title: message });
  }
  yield put(postsListCtrl.action.updateCtrl({ disabled: false }));
}
